import React from 'react'
import PropTypes from 'prop-types'

import { SPACING } from '../components/constants.js'
import Slide from '../components/Slide.jsx'
import Margin from '../components/Margin.jsx'
import Text from '../components/Text.jsx'
import Align from '../components/Align.jsx'
import Gradient from '../components/Gradient.jsx'

import usePosition from '../hooks/usePosition.js'
import useRect from '../hooks/useRect.js'

import datasphereLogo from '_static/img/datasphere-white.png'

const Section = (props) => {
  const { title, backgroundImage, showLogo } = props

  const [Rect, rect] = useRect()
  const [textRef, textRect] = usePosition()

  return (
    <Slide>
      <Rect />
      {backgroundImage ? (
        <image href={backgroundImage} height={rect.height} width={rect.width} x={0} y={0} />
      ) : (
        <Gradient
          direction="bottom"
          colors={[
            { offset: '0%', stopColor: '#10441B' },
            { offset: '100%', stopColor: '#13682B' },
          ]}
        />
      )}
      <Margin left={240} top={SPACING} right={240} bottom={SPACING}>
        <Align childrenRect={textRect} x="left">
          <Text
            value={title}
            gRef={textRef}
            width={1200}
            fill="#ffffff"
            fontSize={64}
            fontWeight={700}
          />
        </Align>
      </Margin>
      {showLogo && (
        <Margin left={0} top={0} right={48} bottom={48}>
          <Align childrenRect={{ width: 1000 / 4, height: 193 / 4 }} x="right" y="bottom">
            <image href={datasphereLogo} width={1000 / 4} height={193 / 4} />
          </Align>
        </Margin>
      )}
    </Slide>
  )
}

Section.propTypes = {
  title: PropTypes.string,
  backgroundImage: PropTypes.string.isRequired,
  showLogo: PropTypes.bool,
}

Section.defaultProps = {
  title: '',
  showLogo: false,
}

export default Section
